import { createContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import * as AuthService from "../Modules/Auth/Service/AuthService";
import useRedirectOnPathChange from "../hooks/useRedirectOnPathChange";
import { PROFILE_TYPES } from "../constants/constants";
import { useNavigate } from "react-router-dom";

export const LoginContext = createContext();

export const Auth = ({ children }) => {
  const navigate = useNavigate();
  const [isUserIn, setIsUserIn] = useState(false);
  const [eventAdminIn, setEventAdminIn] = useState(false);
  const [eventAdmin, setEventAdmin] = useState(null);
  const [user, setUser] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const isFree = user?.profile?.subscription?.tier === PROFILE_TYPES.free;
  
  useRedirectOnPathChange(isUserIn, setIsUserIn);

  const getUserData = async () => {
    setLoading(true);
    try {
      const res = await AuthService.getUser();
      const subsRes = await AuthService.subscriptionDetails();
      setSubscriptionDetails(subsRes);
      setUser(res);
    } catch (err) {
      if (err?.response?.status === 401) {
        localStorage.removeItem("userIn");
        localStorage.removeItem("X-Authorization");
        localStorage.removeItem("X-Refresh");
        localStorage.removeItem("tokenDate");
        setIsUserIn(false);
        setUser(null);
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("X-Authorization");
    if (user === null && token) {
      getUserData();
    }
    const eventToken = localStorage.getItem("event_admin_access");
    if (eventToken) {
      setEventAdminIn(true);
    }
  }, []);

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const refreshToken = localStorage.getItem("X-Refresh");
      if (refreshToken) {
        try {
          const data = await AuthService.userRefreshToken({
            refresh: refreshToken,
          });
          if (data?.access) {
            localStorage.setItem("X-Authorization", data.access);
          }
          if (data?.refresh) {
            localStorage.setItem("X-Refresh", data.refresh);
          }
          localStorage.setItem(
            "tokenDate",
            JSON.stringify(new Date().toISOString()),
          );
        } catch (err) {
          if (err?.response?.status === 401) {
            localStorage.removeItem("userIn");
            localStorage.removeItem("X-Authorization");
            localStorage.removeItem("X-Refresh");
            localStorage.removeItem("tokenDate");
            setIsUserIn(false);
            setUser(null);
            navigate("/");
          }
        }
      }
    }, 165000);

    return () => clearInterval(intervalId);
  }, [navigate]);

  const globalStates = {
    isUserIn,
    setIsUserIn,
    user,
    setUser,
    loading,
    isFree,
    getUserData,
    subscriptionDetails,
    eventAdmin,
    setEventAdmin,
    eventAdminIn,
    setEventAdminIn,
  };

  return (
    <LoginContext.Provider value={globalStates}>
      {loading && <Loading />}
      {children}
    </LoginContext.Provider>
  );
};
